import { createI18n } from 'vue-i18n'

import nb from './lang/nb.json'
import nn from './lang/nn.json'
import en from './lang/en.json'
import ro from './lang/ro.json'
import cs from './lang/cs.json'
import de from './lang/de.json'
import es from './lang/es.json'
import fr from './lang/fr.json'
import sv from './lang/sv.json'
import pt from './lang/pt.json'
import se from './lang/se.json'
import fi from './lang/fi.json'
import pl from './lang/pl.json'
import tr from './lang/tr.json'
import lv from './lang/lt.json'
import lt from './lang/lt.json'

const i18nMessages = {
  en,
  nb,
  nn,
  ro,
  cs,
  de,
  es,
  fr,
  sv,
  pt,
  se,
  fi,
  pl,
  tr,
  lv,
  lt
}

console.log('i18nMessages')
console.log(
  'navigator.language: (%s) (%s) (%s)',
  navigator.language,
  navigator.language.split('-')[0] || 'NOLANG',
  localStorage.getItem('lang')
)

let localLang =
  localStorage.getItem('lang') || navigator.language.split('-')[0] || 'nb'
console.log('localLang: (%s)', localLang)

// const defaultLanguage = 'en'
const i18n = createI18n({
  locale: localLang,
  legacy: false, // allow composition API
  //  locale: 'nb', // defaultLanguage, // set locale
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    nb: i18nMessages.nb,
    nn: i18nMessages.nn,
    en: i18nMessages.en,
    ro: i18nMessages.ro,
    cs: i18nMessages.cs,
    de: i18nMessages.de,
    es: i18nMessages.es,
    fr: i18nMessages.fr,
    sv: i18nMessages.sv,
    pt: i18nMessages.pt,
    se: i18nMessages.se,
    fi: i18nMessages.fi,
    pl: i18nMessages.pl,
    tr: i18nMessages.tr,
    lv: i18nMessages.lv,
    lt: i18nMessages.lt
  } // set locale messages
})

export default i18n
